import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ISaveGrammarSessionV1Request } from './save-grammar-session-v1-request';
import type { ISaveGrammarSessionV1Response } from './save-grammar-session-v1-response';
import { saveGrammarSessionV1ResponseSchema } from './save-grammar-session-v1-response';

export async function saveGrammarSessionV1Api(
  body: ISaveGrammarSessionV1Request,
  options?: IRequestOptions,
): Promise<IValidatedResponse<ISaveGrammarSessionV1Response>> {
  return postRequest<ISaveGrammarSessionV1Response>({
    path: '/grammar/session/v1',
    body,
    schema: saveGrammarSessionV1ResponseSchema,
    options,
  });
}
